const config = {
    apiBaseUrl: 'https://emr-app-api.tretaderma.com',
};

export default config;